<div class="loginForm wrappInside">
  <div class="formWrapp">
    <h2 class="text-center">Sign In</h2>
    <div class="formFeilds">
      <form [formGroup]="loginForm">
        <div class="formGroup">
          <label>Email</label>
          <mat-form-field appearance="outline">
            <input matInput placeholder="Enter your Email" formControlName="email" (blur)="validateUser()" />
          </mat-form-field>
          <div class="errorTxt" *ngIf="!isCustomer && !loginForm?.get('email')?.hasError('required') && !loginForm?.get('email')?.hasError('email')"> This Email Id is not registerd as customer. </div>
          <div class="errorTxt">
            <div *ngIf="loginForm?.get('email')?.touched || loginForm?.get('email')?.dirty">
              <div *ngIf="loginForm?.get('email')?.hasError('required')">Email is required</div>
              <div
                *ngIf="
                  loginForm?.get('email')?.value != '' &&
                  (loginForm?.get('email')?.hasError('numericAfterDotCom') || loginForm?.get('email')?.hasError('email'))
                "
              >
                Must be a valid email address
              </div>
            </div>
          </div>
        </div>
        <div class="formGroup">
          <label>Password</label>
          <mat-form-field appearance="outline">
            <input
              id="login_module_login_form_1"
              matInput
              placeholder="Enter your Password"
              formControlName="passWord"
              [type]="hide ? 'password' : 'text'"
              (keyup.enter)="onSubmit()"
            />
            <mat-icon matSuffix (click)="togglePasswordVisibility()">
              {{ hide ? "visibility_off" : "visibility" }}
            </mat-icon>
          </mat-form-field>
          <div class="errorTxt">
            <div *ngIf="loginForm?.get('passWord')?.touched || loginForm?.get('passWord')?.dirty">
              <div *ngIf="loginForm?.get('passWord')?.hasError('required')">Password is required</div>
            </div>
          </div>
        </div>
        <div class="formGroup mt-20">
          <button
            id="login_module_login_form_2"
            mat-button
            color="primary"
            type="submit"
            class="primaryButton ctaBlack"
            [ngClass]="{ disable: isValid() }"
            [disabled]="!isCustomer"
            (click)="onSubmit()"
          >
            Continue
          </button>
        </div>
      </form>
      <div  class="signupLink">Don't have an account? <span (click)="customerSignup()">Create Account</span></div>
    </div>
  </div>
</div>
